import { Injectable } from "@angular/core";
import { Context } from "vm";
import { CompleteDesignerContext } from "app/private/sxfdesigner/components/main/completeContext";
import { DesignerCachableOutput, DesignerCachableInputs } from "app/private/sxfdesigner/types/designer-context-type";

const CURRENT_FLOW_ID_KEY = "currentFlowId"

const CURRENT_USER = "currentUser";
const CONFIG_CTX_LOCALSTORAGE_KEY = 'configurationContext';
const ROLES_LOCALSTORAGE_KEY = 'configurationRol';
const SECATT_LOCALSTORAGE_KEY = 'configurationSecAtt';
const COMPLETE_CONTEXT_KEY = 'completeDesignerContext';
const DESIGNER_RULE_KEY = 'designerRuleCode';

@Injectable()
export class CacheService {
  
    getCurrentFlowId() {
        let key = localStorage.getItem(CURRENT_FLOW_ID_KEY)
        // Convert string to number
        return +key
    }

    setCurrentFlowId(value: number) {
        localStorage.setItem(CURRENT_FLOW_ID_KEY, value.toString())
    }

    getCurrentUser(){
      return localStorage.getItem(CURRENT_USER);
    }

    setCurrentUser(value){
      localStorage.setItem(CURRENT_USER, value.name.toString());
    }
  /**
   * Determina si el token ha sido almacenado
   */
  isContextCached() {
    // if(!environment.production)
    //  this.setContext({user: null,tenantCode:"TN",sysCode: "DEMO",productCode: null})
    return localStorage.getItem(CONFIG_CTX_LOCALSTORAGE_KEY) != null;
  }
 /**
   * Si el contexto esta presente, lo retorna, sino devuelve null
   */
  getContext(): Context {
    if (this.isContextCached()) {
      const ctx: Context = JSON.parse(localStorage.getItem(CONFIG_CTX_LOCALSTORAGE_KEY));
      return ctx;
    }
    return null;
  }

  /**
    * Almacena el contexto en el LocalStorage
    */
  setContext(ctx: Context) {
    localStorage.setItem(CONFIG_CTX_LOCALSTORAGE_KEY, JSON.stringify(ctx));
  }

  /**
   * Remueve el contexto del LocalStorage
   */
  removeContext() {
    localStorage.removeItem(CONFIG_CTX_LOCALSTORAGE_KEY);
  }


  saveTemp(f: any, key: string) {
    localStorage.setItem(key, JSON.stringify(f));
  }

  getTemp(key: string): any {
    return JSON.parse(localStorage.getItem(key));
  }

  setDesignerOutputs(context: DesignerCachableOutput){
    localStorage.setItem(COMPLETE_CONTEXT_KEY, JSON.stringify(context));
  }

  getDesignerOutputs(): DesignerCachableOutput {
    return JSON.parse(localStorage.getItem(COMPLETE_CONTEXT_KEY));
  }

  removeDesignerOutputs() {
    localStorage.removeItem(COMPLETE_CONTEXT_KEY);
  }

  setDesignerInputs(code: DesignerCachableInputs){
    localStorage.setItem(DESIGNER_RULE_KEY, JSON.stringify(code));
  }

  getDesignerInputs(): DesignerCachableInputs {
    return JSON.parse(localStorage.getItem(DESIGNER_RULE_KEY));
  }

  removeDesignerInputs() {
    localStorage.removeItem(DESIGNER_RULE_KEY);
  }

}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/cache.service.ts